import sec_one from '../../img/section/sec_one_ic.png';
import sec_two from '../../img/section/sec_two_ic.png';
import sec_three from '../../img/section/sec_three_ic.png';
import sec_four from '../../img/section/sec_four_ic.png';
import sec_five from '../../img/section/sec_five_ic.png';
import sec_six from '../../img/section/sec_six_ic.png';
import sec_seven from '../../img/section/sec_seven_ic.png';

export const getProgressData = (value) => {
    if (value > 75) {
        return { text: "msgProgress0", color: "color-green" };
    } else if (value > 25) {
        return { text: "msgProgress0", color: "color-orange" };
    } else {
        return { text: "msgProgress0", color: "color-red" };
    }
}

export const getBlockImage = (item) => {
    switch (item.id_block) {
        case 2:
            return sec_two;
        case 3:
            return sec_three;
        case 4:
            return sec_four;
        case 5:
            return sec_five;
        case 6:
            return sec_six;
        case 7:
            return sec_seven;
        default:
            return sec_one;
    }
}